/**
 * @generated SignedSource<<bb34754e73435aa1afb883736c4b2e87>>
 * @relayHash 7b26961ef5838cb13cb7f9dc844c1153
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8324052c2d9d0c52ae3f95796834e14c20dd3358576d66231a9a729cba64240

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null;
  customInput?: JiraIssueSearchCustomInput | null;
  filterId?: string | null;
  groupByInput?: JiraIssueSearchGroupByInput | null;
  jql?: string | null;
  searchWithLastUsedJql?: boolean | null;
};
export type JiraIssueSearchChildIssuesInput = {
  applyJqlFilter?: boolean | null;
  filterByProjectKeys?: ReadonlyArray<string> | null;
  filterId?: string | null;
  jql?: string | null;
  namespace?: string | null;
  parentIssueKey: string;
  viewId?: string | null;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null;
  context?: JiraSoftwareIssueSearchCustomInputContext | null;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null;
  hideUnParentedItems?: boolean | null;
  maxHierarchyLevel?: number | null;
  quickFilterIds?: ReadonlyArray<string> | null;
  useSavedFilters?: boolean | null;
};
export type JiraIssueSearchGroupByInput = {
  groupByJql?: string | null;
  jql?: string | null;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null;
  viewInput?: JiraIssueSearchViewInput | null;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null;
  filterId?: string | null;
  namespace?: string | null;
  viewId?: string | null;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null;
  project?: string | null;
};
export type IssueTableViewQuery$variables = {
  after?: string | null;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null;
  filterAri: string;
  first?: number | null;
  isNotFilterFetch: boolean;
  issueSearchInput: JiraIssueSearchInput;
};
export type IssueTableViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueTableView">;
};
export type IssueTableViewQuery = {
  response: IssueTableViewQuery$data;
  variables: IssueTableViewQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": isFieldCellExtractionEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": isUseNodeIdForRowKeyDisabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider": isTimelineHarmonisationM3PerformanceDisabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": blockAttachmentDownloadSegregation_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": isColouredDueDateUiChangesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": shouldFetchDelegatorForList_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldFetchDelegator_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": shouldSurfaceAgentAssignee_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFormulaFieldD2D3Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": isColorFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": isDateRangeFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": isUseNodeIdForRowKeyEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": cmdbFirst_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled": isJiraForgeCustomFieldsInIssueNavigatorEditEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": caterRichTextWithPlainTextRenderer_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": isPrivateGoalsFieldReadEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": isProjectsInJiraGaDropEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider: {
    readonly get: () => number | null;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider: {
    readonly get: () => boolean;
  };
});

import shouldFetchDelegatorForList_provider from '@jira/platform__graphql-relay-provider/src/EmpanadaAssigneeAgentDelegateFixRelayprovider';
import isFormulaFieldD2D3Enabled_provider from '@jira/platform__graphql-relay-provider/src/FrontierFormulaFieldD2D3Relayprovider';
import isDateRangeFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/IssueTableDateRangeFieldRelayProvider';
import isTimelineHarmonisationM3PerformanceDisabled_provider from '@jira/platform__graphql-relay-provider/src/JiraTimelineHarmonisationM3PerformanceDisabledRelayProvider';
import isColouredDueDateUiChangesEnabled_provider from '@jira/platform__graphql-relay-provider/src/JivColouredDueDateUiChangesRelayprovider';
import shouldSurfaceAgentAssignee_provider from '@jira/platform__graphql-relay-provider/src/JsmSurfaceAgentAssigneeRelayProvider';
import caterRichTextWithPlainTextRenderer_provider from '@jira/platform__graphql-relay-provider/src/NinCaterRichTextWithPlainTextRendererRelayProvider';
import isFieldCellExtractionEnabled_provider from '@jira/platform__graphql-relay-provider/src/NinFieldCellExtractionRelayProvider';
import isPrivateGoalsFieldReadEnabled_provider from '@jira/platform__graphql-relay-provider/src/PrivateGoalsInJiraRelayProvider';
import isUseNodeIdForRowKeyDisabled_provider from '@jira/platform__graphql-relay-provider/src/UseNodeIdForRowKeyDisabledRelayProvider';
import cmdbFirst_provider from '@jira/platform__graphql-relay-provider/src/assets-custom-fields-limit-increase.relayprovider';
import isAtlasProjectEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration.relayprovider';
import blockAttachmentDownloadSegregation_provider from '@jira/platform__graphql-relay-provider/src/block-attachment-download-segregation.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@jira/platform__graphql-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@jira/platform__graphql-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJiraForgeCustomFieldsInIssueNavigatorEditEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraForgeCustomFieldsInIssueNavigatorEditEnabled';
import isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraForgeCustomFieldsInIssueNavigatorEnabled.relayprovider';
import isColorFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/issue-table-color-field.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchDelegator_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@jira/platform__graphql-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';
import isProjectsInJiraGaDropEnabled_provider from '@jira/platform__graphql-relay-provider/src/projectsInJiraGaDropRelayProvider';
import isUseNodeIdForRowKeyEnabled_provider from '@jira/platform__graphql-relay-provider/src/use-node-id-for-row-key.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterAri"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNotFilterFetch"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v17 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v18 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v10/*: any*/)
  ]
},
v19 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v10/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "__id"
},
v21 = {
  "kind": "ClientExtension",
  "selections": [
    (v20/*: any*/)
  ]
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canBeExported"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canDownloadAttachment"
        }
      ]
    }
  ],
  "type": "JiraIssue"
},
v23 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v24 = {
  "kind": "ScalarField",
  "name": "picture"
},
v25 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "resolutionPlanAssigneeProperty",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "jsm_resolution_plan_property"
            }
          ],
          "kind": "ScalarField",
          "name": "issuePropertyByKey",
          "storageKey": "issuePropertyByKey(key:\"jsm_resolution_plan_property\")"
        },
        {
          "concreteType": "JiraProjectField",
          "kind": "LinkedField",
          "name": "projectField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "projectType"
                },
                (v10/*: any*/)
              ]
            },
            (v10/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "delegator",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v14/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v10/*: any*/)
          ]
        }
      ]
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "type"
},
v27 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v28 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v29 = {
  "kind": "ScalarField",
  "name": "text"
},
v30 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v31 = {
  "kind": "ClientExtension",
  "selections": [
    (v30/*: any*/)
  ]
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    (v29/*: any*/),
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        (v14/*: any*/),
        (v10/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v14/*: any*/),
                (v10/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v35 = {
  "kind": "ScalarField",
  "name": "value"
},
v36 = [
  (v35/*: any*/),
  (v10/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v36/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v36/*: any*/)
        }
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraCascadingSelectField"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
        }
      ],
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v39 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v40 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v41 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v40/*: any*/),
                (v41/*: any*/),
                (v10/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedComponentsConnection(first:1000)"
    },
    (v31/*: any*/)
  ],
  "type": "JiraComponentsField"
},
v43 = {
  "kind": "ScalarField",
  "name": "date"
},
v44 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    (v14/*: any*/),
    (v44/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v46 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v47 = {
  "kind": "ScalarField",
  "name": "formattedText"
},
v48 = [
  (v14/*: any*/)
],
v49 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "number"
},
v51 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v52 = [
  (v14/*: any*/),
  (v10/*: any*/)
],
v53 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v54 = [
  (v9/*: any*/),
  (v23/*: any*/),
  (v14/*: any*/),
  (v24/*: any*/),
  (v10/*: any*/)
],
v55 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v46/*: any*/),
        (v47/*: any*/)
      ],
      "type": "JiraForgeDatetimeField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/),
        (v47/*: any*/),
        (v49/*: any*/),
        (v31/*: any*/)
      ],
      "type": "JiraForgeDateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v50/*: any*/),
        (v47/*: any*/),
        (v49/*: any*/),
        (v31/*: any*/)
      ],
      "type": "JiraForgeNumberField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v29/*: any*/),
        (v47/*: any*/),
        (v49/*: any*/),
        (v31/*: any*/)
      ],
      "type": "JiraForgeStringField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        {
          "args": (v39/*: any*/),
          "concreteType": "JiraLabelConnection",
          "kind": "LinkedField",
          "name": "selectedLabelsConnection",
          "plural": false,
          "selections": [
            (v51/*: any*/),
            {
              "concreteType": "JiraLabelEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraLabel",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v48/*: any*/)
                }
              ]
            }
          ],
          "storageKey": "selectedLabelsConnection(first:1000)"
        }
      ],
      "type": "JiraForgeStringsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "selectedGroup",
          "plural": false,
          "selections": (v52/*: any*/)
        }
      ],
      "type": "JiraForgeGroupField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        {
          "concreteType": "JiraGroupConnection",
          "kind": "LinkedField",
          "name": "selectedGroupsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v53/*: any*/),
                    (v14/*: any*/),
                    (v10/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraForgeGroupsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v54/*: any*/)
        }
      ],
      "type": "JiraForgeUserField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v54/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraForgeUsersField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "object"
            },
            (v14/*: any*/)
          ]
        },
        (v31/*: any*/)
      ],
      "type": "JiraForgeObjectField"
    }
  ]
},
v56 = {
  "kind": "InlineFragment",
  "selections": [
    (v46/*: any*/),
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v57 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "start"
        },
        {
          "kind": "ScalarField",
          "name": "end"
        }
      ],
      "type": "JiraDateRangeField"
    }
  ]
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v17/*: any*/),
        (v10/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v60 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v60/*: any*/),
        (v18/*: any*/),
        (v10/*: any*/)
      ]
    },
    (v21/*: any*/)
  ],
  "type": "JiraStatusField"
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategoryProgressConnection",
      "kind": "LinkedField",
      "name": "aggregatedStatusCategory",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraStatusCategoryProgressEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraStatusCategoryProgress",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": [
                    (v12/*: any*/),
                    (v10/*: any*/)
                  ]
                },
                (v35/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAggregatedStatusField"
},
v63 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v10/*: any*/)
  ]
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        (v51/*: any*/),
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v14/*: any*/),
                (v63/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v65 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        {
          "concreteType": "JiraColorField",
          "kind": "LinkedField",
          "name": "issueColorField",
          "plural": false,
          "selections": [
            (v63/*: any*/),
            (v10/*: any*/)
          ]
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v65/*: any*/),
                (v14/*: any*/),
                (v10/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "issueTypeId"
                },
                (v13/*: any*/)
              ]
            },
            (v10/*: any*/),
            (v28/*: any*/)
          ]
        },
        {
          "concreteType": "JiraSingleLineTextField",
          "kind": "LinkedField",
          "name": "summaryField",
          "plural": false,
          "selections": [
            (v29/*: any*/),
            (v10/*: any*/),
            (v28/*: any*/)
          ]
        },
        (v10/*: any*/),
        (v11/*: any*/),
        (v66/*: any*/),
        {
          "concreteType": "JiraStatusField",
          "kind": "LinkedField",
          "name": "statusField",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            (v28/*: any*/),
            (v19/*: any*/)
          ]
        }
      ]
    },
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraParentIssueField"
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        (v10/*: any*/)
      ]
    },
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v12/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v10/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v52/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v71 = {
  "kind": "ScalarField",
  "name": "state"
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v14/*: any*/),
                (v71/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ]
        }
      ]
    },
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraSprintField"
},
v73 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v74 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appType"
    }
  ],
  "type": "AppUser"
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v14/*: any*/),
        (v24/*: any*/),
        (v73/*: any*/),
        (v10/*: any*/),
        (v23/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            (v74/*: any*/),
            (v75/*: any*/)
          ]
        },
        (v75/*: any*/)
      ]
    },
    (v44/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "json"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v65/*: any*/),
        (v10/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementOrganizationConnection",
      "kind": "LinkedField",
      "name": "selectedOrganizationsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraServiceManagementOrganizationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraServiceManagementOrganization",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "organizationName"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementOrganizationField"
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "JiraAgentSessionConnection",
      "kind": "LinkedField",
      "name": "agentSessions",
      "plural": false,
      "selections": [
        (v51/*: any*/),
        {
          "concreteType": "JiraAgentSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAgentSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v71/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    (v74/*: any*/),
                    (v24/*: any*/),
                    (v75/*: any*/),
                    (v10/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "stateCategory"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "agentSessions(first:50)"
    }
  ],
  "type": "JiraAgentSessionsField"
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v51/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v66/*: any*/),
                    (v12/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v9/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v18/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v10/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    {
                      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        (v16/*: any*/)
                      ]
                    },
                    (v10/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v10/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v82 = {
  "kind": "ScalarField",
  "name": "formatStyle"
},
v83 = {
  "kind": "ScalarField",
  "name": "formatUnit"
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v50/*: any*/),
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        (v82/*: any*/),
        (v83/*: any*/)
      ]
    },
    (v14/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraNumberField"
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        (v51/*: any*/)
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "uri"
    },
    (v31/*: any*/)
  ],
  "type": "JiraUrlField"
},
v87 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v88 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        (v63/*: any*/),
        (v10/*: any*/),
        (v87/*: any*/)
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraSingleSelectField"
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v35/*: any*/),
                (v87/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraMultipleSelectField"
},
v90 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v35/*: any*/)
  ]
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v90/*: any*/)
          ]
        }
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraCheckboxesField"
},
v92 = {
  "concreteType": "JiraUserConnection",
  "kind": "LinkedField",
  "name": "selectedUsersConnection",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v23/*: any*/),
            (v14/*: any*/),
            (v24/*: any*/),
            (v10/*: any*/),
            (v73/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ]
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v92/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraMultipleSelectUserPickerField"
},
v94 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraTeamViewField"
},
v95 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraEstimate",
              "kind": "LinkedField",
              "name": "originalEstimate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "timeInSeconds"
                }
              ]
            },
            {
              "concreteType": "JiraTimeTrackingSettings",
              "kind": "LinkedField",
              "name": "timeTrackingSettings",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "workingHoursPerDay"
                },
                {
                  "kind": "ScalarField",
                  "name": "workingDaysPerWeek"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultFormat"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultUnit"
                }
              ]
            },
            (v10/*: any*/),
            (v28/*: any*/),
            (v14/*: any*/),
            (v26/*: any*/)
          ]
        },
        (v10/*: any*/)
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraOriginalTimeEstimateField"
},
v96 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        {
          "alias": "label",
          "kind": "ScalarField",
          "name": "value"
        },
        (v10/*: any*/),
        (v40/*: any*/)
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraRadioSelectField"
},
v97 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v14/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "versionId"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    },
    (v31/*: any*/)
  ],
  "type": "JiraMultipleVersionPickerField"
},
v98 = [
  (v10/*: any*/)
],
v99 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v98/*: any*/)
},
v100 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v99/*: any*/),
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v12/*: any*/),
                (v14/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "status"
                },
                {
                  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "isPrivate"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v21/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        (v20/*: any*/),
        (v30/*: any*/)
      ]
    }
  ],
  "type": "JiraGoalsField"
},
v101 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        (v99/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isLinkEditable"
        },
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "alias": "atlasProjectName",
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "alias": "atlasProjectKey",
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "privateProject"
            },
            {
              "kind": "ScalarField",
              "name": "hasPermission"
            },
            {
              "kind": "ScalarField",
              "name": "isWorkspaceActive"
            },
            {
              "kind": "ScalarField",
              "name": "iconName"
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isLinkInherited"
            },
            {
              "kind": "ScalarField",
              "name": "isParentLinked"
            }
          ]
        },
        (v31/*: any*/)
      ],
      "type": "JiraTownsquareProjectField"
    }
  ]
},
v102 = {
  "kind": "ScalarField",
  "name": "href"
},
v103 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v102/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "pageContent",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v102/*: any*/)
                      ],
                      "type": "JiraConfluencePageContentDetails"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v51/*: any*/)
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    },
    (v31/*: any*/)
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v14/*: any*/),
                (v53/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v31/*: any*/)
  ],
  "type": "JiraMultipleGroupPickerField"
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
},
v106 = {
  "kind": "ScalarField",
  "name": "count"
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        (v106/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isWatching"
        }
      ]
    }
  ],
  "type": "JiraWatchesField"
},
v108 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v50/*: any*/),
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        (v82/*: any*/),
        (v83/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "durationUnits"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNumberFormulaField"
},
v109 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        (v29/*: any*/)
      ],
      "type": "JiraTextFormulaField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v46/*: any*/),
        (v14/*: any*/)
      ],
      "type": "JiraDateFormulaField"
    }
  ]
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isMulti"
    },
    (v92/*: any*/),
    (v31/*: any*/)
  ],
  "type": "JiraPeopleField"
},
v111 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v63/*: any*/)
      ],
      "type": "JiraColorField"
    }
  ]
},
v112 = [
  (v106/*: any*/)
],
v113 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v114 = {
  "kind": "ScalarField",
  "name": "stateCount"
},
v115 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueDevSummary",
      "kind": "LinkedField",
      "name": "devSummary",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        {
          "concreteType": "JiraIssueBranchDevSummaryContainer",
          "kind": "LinkedField",
          "name": "branch",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueBranchDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v112/*: any*/)
            }
          ]
        },
        {
          "concreteType": "JiraIssueCommitDevSummaryContainer",
          "kind": "LinkedField",
          "name": "commit",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueCommitDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v106/*: any*/),
                (v113/*: any*/)
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssuePullRequestDevSummaryContainer",
          "kind": "LinkedField",
          "name": "pullrequest",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssuePullRequestDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v113/*: any*/),
                (v114/*: any*/),
                (v71/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "open"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueReviewDevSummaryContainer",
          "kind": "LinkedField",
          "name": "review",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueReviewDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v113/*: any*/),
                (v114/*: any*/),
                (v71/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "completed"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueBuildDevSummaryContainer",
          "kind": "LinkedField",
          "name": "build",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueBuildDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v106/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "failedBuildCount"
                },
                {
                  "kind": "ScalarField",
                  "name": "successfulBuildCount"
                },
                {
                  "kind": "ScalarField",
                  "name": "unknownBuildCount"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
          "kind": "LinkedField",
          "name": "deploymentEnvironments",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v112/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": (v98/*: any*/)
        },
        (v10/*: any*/)
      ]
    }
  ],
  "type": "JiraDevSummaryField"
},
v116 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "durationInSeconds"
    },
    (v29/*: any*/)
  ],
  "type": "JiraDurationField"
},
v117 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementFeedback",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "rating"
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestFeedbackField"
},
v118 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementSla",
      "kind": "LinkedField",
      "name": "sla",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraServiceManagementSlaError",
          "kind": "LinkedField",
          "name": "error",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "errorCode"
            },
            {
              "kind": "ScalarField",
              "name": "goalId"
            },
            {
              "kind": "ScalarField",
              "name": "timeMetricId"
            }
          ]
        },
        {
          "concreteType": "JiraServiceManagementSlaGoalView",
          "kind": "LinkedField",
          "name": "goalView",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "paused"
            },
            {
              "kind": "ScalarField",
              "name": "active"
            },
            {
              "kind": "ScalarField",
              "name": "closed"
            },
            {
              "kind": "ScalarField",
              "name": "failed"
            },
            {
              "kind": "ScalarField",
              "name": "emergencyLevel"
            },
            {
              "kind": "ScalarField",
              "name": "remainingTime"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementSlaField"
},
v119 = {
  "kind": "ScalarField",
  "name": "jql"
},
v120 = [
  {
    "kind": "ScalarField",
    "name": "cursor"
  },
  {
    "kind": "ScalarField",
    "name": "pageNumber"
  },
  {
    "kind": "ScalarField",
    "name": "isCurrent"
  }
],
v121 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueTableViewQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "IssueTableView"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueTableViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "fieldSetsInput",
                "variableName": "fieldSetsInput"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "issueSearchInput",
                "variableName": "issueSearchInput"
              }
            ],
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearchStable",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraListRowEdge"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v10/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/)
                                ]
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraListRow"
                          },
                          (v16/*: any*/),
                          {
                            "concreteType": "JiraStatusField",
                            "kind": "LinkedField",
                            "name": "statusField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "summary"
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v21/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "type": "JiraListRow",
                                    "abstractKey": "__isJiraListRow"
                                  },
                                  (v25/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "type": "JiraIssue"
                              }
                            ]
                          },
                          (v21/*: any*/),
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              (v22/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v25/*: any*/)
                                ],
                                "type": "JiraIssue"
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isHighlightedIssueRow"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraListRowFieldSetConnection"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraListRowFieldSet"
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v9/*: any*/),
                                              (v28/*: any*/),
                                              (v26/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v32/*: any*/),
                                                  (v33/*: any*/)
                                                ],
                                                "type": "JiraIssueField",
                                                "abstractKey": "__isJiraIssueField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      (v37/*: any*/),
                                                      (v38/*: any*/),
                                                      (v42/*: any*/),
                                                      (v45/*: any*/),
                                                      (v55/*: any*/),
                                                      (v56/*: any*/),
                                                      (v57/*: any*/),
                                                      (v58/*: any*/),
                                                      (v59/*: any*/),
                                                      (v61/*: any*/),
                                                      (v62/*: any*/),
                                                      (v64/*: any*/),
                                                      (v67/*: any*/),
                                                      (v68/*: any*/),
                                                      (v69/*: any*/),
                                                      (v70/*: any*/),
                                                      (v72/*: any*/),
                                                      (v76/*: any*/),
                                                      (v77/*: any*/),
                                                      (v78/*: any*/),
                                                      (v79/*: any*/),
                                                      (v80/*: any*/),
                                                      (v81/*: any*/),
                                                      (v84/*: any*/),
                                                      (v85/*: any*/),
                                                      (v86/*: any*/),
                                                      (v88/*: any*/),
                                                      (v89/*: any*/),
                                                      (v91/*: any*/),
                                                      (v93/*: any*/),
                                                      (v94/*: any*/),
                                                      (v95/*: any*/),
                                                      (v96/*: any*/),
                                                      (v97/*: any*/),
                                                      (v100/*: any*/),
                                                      (v101/*: any*/),
                                                      (v103/*: any*/),
                                                      (v104/*: any*/),
                                                      (v105/*: any*/),
                                                      (v107/*: any*/),
                                                      (v108/*: any*/),
                                                      (v109/*: any*/),
                                                      (v110/*: any*/),
                                                      (v111/*: any*/),
                                                      (v115/*: any*/),
                                                      (v116/*: any*/),
                                                      (v117/*: any*/),
                                                      (v118/*: any*/)
                                                    ],
                                                    "type": "JiraIssueField",
                                                    "abstractKey": "__isJiraIssueField"
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v29/*: any*/)
                                                        ],
                                                        "type": "JiraRemoteSingleLineTextField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "avatarUrl"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeName"
                                                          }
                                                        ],
                                                        "type": "JiraRemoteIssueTypeField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "priorityName"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "priorityIconUrl"
                                                          }
                                                        ],
                                                        "type": "JiraRemotePriorityField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "userDisplayName"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "avatarSmall"
                                                          }
                                                        ],
                                                        "type": "JiraRemoteSingleSelectUserPickerField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v60/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "statusName"
                                                          },
                                                          (v17/*: any*/)
                                                        ],
                                                        "type": "JiraRemoteStatusField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": (v48/*: any*/),
                                                        "type": "JiraRemoteGenericField"
                                                      }
                                                    ],
                                                    "type": "JiraRemoteIssueField",
                                                    "abstractKey": "__isJiraRemoteIssueField"
                                                  }
                                                ]
                                              },
                                              (v21/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v90/*: any*/),
                                                          (v21/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCheckboxesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "fieldOption",
                                                    "plural": false,
                                                    "selections": [
                                                      (v87/*: any*/),
                                                      (v10/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraSingleSelectField"
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      (v80/*: any*/),
                                                      (v37/*: any*/),
                                                      (v38/*: any*/),
                                                      (v42/*: any*/),
                                                      (v45/*: any*/),
                                                      (v55/*: any*/),
                                                      (v56/*: any*/),
                                                      (v109/*: any*/),
                                                      (v57/*: any*/),
                                                      (v58/*: any*/),
                                                      (v32/*: any*/),
                                                      (v59/*: any*/),
                                                      (v61/*: any*/),
                                                      (v62/*: any*/),
                                                      (v64/*: any*/),
                                                      (v33/*: any*/),
                                                      (v67/*: any*/),
                                                      (v68/*: any*/),
                                                      (v69/*: any*/),
                                                      (v70/*: any*/),
                                                      (v72/*: any*/),
                                                      (v76/*: any*/),
                                                      (v77/*: any*/),
                                                      (v78/*: any*/),
                                                      (v79/*: any*/),
                                                      (v81/*: any*/),
                                                      (v84/*: any*/),
                                                      (v85/*: any*/),
                                                      (v86/*: any*/),
                                                      (v88/*: any*/),
                                                      (v89/*: any*/),
                                                      (v91/*: any*/),
                                                      (v93/*: any*/),
                                                      (v94/*: any*/),
                                                      (v95/*: any*/),
                                                      (v96/*: any*/),
                                                      (v97/*: any*/),
                                                      (v100/*: any*/),
                                                      (v101/*: any*/),
                                                      (v103/*: any*/),
                                                      (v104/*: any*/),
                                                      (v105/*: any*/),
                                                      (v107/*: any*/),
                                                      (v108/*: any*/),
                                                      (v110/*: any*/),
                                                      (v111/*: any*/),
                                                      (v115/*: any*/),
                                                      (v116/*: any*/),
                                                      (v117/*: any*/),
                                                      (v118/*: any*/)
                                                    ],
                                                    "type": "JiraIssueField",
                                                    "abstractKey": "__isJiraIssueField"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraListRowFieldConnection"
                                      }
                                    ]
                                  },
                                  (v21/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldSets(first:500)"
                      },
                      (v21/*: any*/)
                    ]
                  },
                  (v119/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "totalIssueSearchResultCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isCappingIssueSearchResult"
                  },
                  {
                    "concreteType": "JiraIssueNavigatorPageInfo",
                    "kind": "LinkedField",
                    "name": "issueNavigatorPageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                      }
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                      },
                      {
                        "kind": "Variable",
                        "name": "pageSize",
                        "variableName": "first"
                      }
                    ],
                    "concreteType": "JiraPageCursors",
                    "kind": "LinkedField",
                    "name": "pageCursors",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": (v120/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": (v120/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": (v120/*: any*/)
                      }
                    ]
                  },
                  (v21/*: any*/)
                ],
                "type": "JiraListRowConnection",
                "abstractKey": "__isJiraListRowConnection"
              }
            ]
          },
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "fieldSetIds",
                "variableName": "fieldSetIds"
              }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v26/*: any*/),
                      (v121/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "aliases"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isSortable"
                      },
                      {
                        "concreteType": "JiraFieldSetPreferences",
                        "kind": "LinkedField",
                        "name": "fieldSetPreferences",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "width"
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                            "kind": "LinkedField",
                            "name": "fieldsMetadata",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchMetadataField",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "canBeConfigured"
                                      },
                                      (v28/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isPlaceHolderField"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraFieldType",
                        "kind": "LinkedField",
                        "name": "fieldType",
                        "plural": false,
                        "selections": [
                          (v121/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v51/*: any*/),
              (v21/*: any*/)
            ]
          },
          {
            "condition": "isNotFilterFetch",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "filterAri"
                  }
                ],
                "kind": "LinkedField",
                "name": "filter",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v14/*: any*/),
                  (v119/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b8324052c2d9d0c52ae3f95796834e14c20dd3358576d66231a9a729cba64240",
    "metadata": {},
    "name": "IssueTableViewQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": isFieldCellExtractionEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": isUseNodeIdForRowKeyDisabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider": isTimelineHarmonisationM3PerformanceDisabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": blockAttachmentDownloadSegregation_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": isColouredDueDateUiChangesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": shouldFetchDelegatorForList_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldFetchDelegator_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": shouldSurfaceAgentAssignee_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFormulaFieldD2D3Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": isColorFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": isDateRangeFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": isUseNodeIdForRowKeyEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": cmdbFirst_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled": isJiraForgeCustomFieldsInIssueNavigatorEditEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": caterRichTextWithPlainTextRenderer_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": isPrivateGoalsFieldReadEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": isProjectsInJiraGaDropEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider
    }
  }
};
})();

(node as any).hash = "78397a7dc374c0a1e5d3b2c5219bdd18";

export default node;
